import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { API_URL } from "../../Utils/Url.jsx";

// Turns a stored picture path (or a full link) into something the browser can load.
export const resolveOfferImage = (src) => {
  if (!src || typeof src !== "string") return "";
  if (/^(https?:|data:|blob:)/.test(src)) return src;
  return `${API_URL.replace(/\/api\/v1\/?$/, "")}/${src.replace(/^\//, "")}`;
};

// A card picture for combo and BOGO offers. Shows the cover; with several pictures it flips through
// them while the mouse is over the card, and the dots let a phone user tap to the next one.
const OfferImage = ({ images = [], alt = "", fit = "cover", imgClassName = "", grayscale = false, fallback = null, fill = false, dotsTop = false }) => {
  const list = (images || []).map(resolveOfferImage).filter(Boolean);
  const [index, setIndex] = useState(0);
  const [hover, setHover] = useState(false);
  const count = list.length;

  useEffect(() => {
    if (!hover || count < 2) return undefined;
    const t = setInterval(() => setIndex((i) => (i + 1) % count), 1200);
    return () => clearInterval(t);
  }, [hover, count]);

  useEffect(() => { if (!hover) setIndex(0); }, [hover]);

  if (!count) return fallback;
  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={fill ? { position: "absolute", inset: 0 } : { position: "relative", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        component="img"
        className={imgClassName}
        src={list[Math.min(index, count - 1)]}
        alt={alt}
        sx={{
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: fit,
          filter: grayscale ? "grayscale(30%)" : "none",
          transition: "transform 0.4s ease",
        }}
      />
      {count > 1 && (
        <Box sx={{ position: "absolute", ...(dotsTop ? { top: 12, right: 12, left: "auto" } : { bottom: 8, left: 0, right: 0 }), display: "flex", justifyContent: "center", gap: "5px", zIndex: 6 }}>
          {list.map((_, i) => (
            <Box
              key={i}
              onClick={(e) => { e.stopPropagation(); setIndex(i); }}
              sx={{ width: i === index ? 16 : 7, height: 7, borderRadius: "4px", bgcolor: i === index ? "#C8A054" : "rgba(0,0,0,0.25)", transition: "all 0.25s ease", cursor: "pointer" }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default OfferImage;
